/**
 * Schaltbare Funktionen des Schüler-Portals.
 * Die Liste kommt beim Login aus /api/me und wird in app.ts einmalig gesetzt,
 * damit die Schüler-Seiten Unterfunktionen abfragen können, ohne app.ts zu importieren.
 *
 * Reine Anzeige-Logik: Die verbindliche Prüfung passiert im Backend
 * (backend/src/services/student-portal-features.ts).
 */

let enabled = new Set<string>();

export function setPortalFeatures(keys: string[]): void {
  enabled = new Set(keys);
}

export function hasPortalFeature(key: string | undefined): boolean {
  return !key || enabled.has(key);
}
